/* Hero Black Friday (homepage): numărătoare, film de fundal, confetti/scântei/sticle pe canvas și
   momentul „se aprinde lumina” cu GSAP. Conținutul e vizibil implicit; .is-pre îl ascunde doar până pornește animația. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function rand(a, b) { return a + Math.random() * (b - a); }

  /* ---------- numărătoarea ---------- */
  function countdown(root) {
    var box = root.querySelector('[data-nvbfh-count]');
    var started = root.querySelector('[data-nvbfh-started]');
    var start = Date.parse(root.getAttribute('data-start') || '');
    if (!box || isNaN(start)) { if (box) box.hidden = true; return; }
    var cells = {}, last = {}, timer;
    box.querySelectorAll('[data-u]').forEach(function (el) { cells[el.getAttribute('data-u')] = el; });
    function set(u, v, tick) {
      if (last[u] === v) return;
      last[u] = v; cells[u].textContent = v;
      if (tick && window.gsap && !reduce) {
        gsap.fromTo(cells[u], { yPercent: -35, autoAlpha: 0.35 }, { yPercent: 0, autoAlpha: 1, duration: 0.35, ease: 'expo.out', overwrite: true });
      }
    }
    function render(tick) {
      var ms = start - Date.now();
      if (ms <= 0) { box.hidden = true; if (started) started.hidden = false; clearInterval(timer); return; }
      var t = Math.floor(ms / 1000);
      set('d', String(Math.floor(t / 86400)), tick);
      set('h', pad(Math.floor(t % 86400 / 3600)), tick);
      set('m', pad(Math.floor(t % 3600 / 60)), tick);
      set('s', pad(t % 60), tick);
    }
    render(false);
    timer = setInterval(function () { if (!document.hidden) render(true); }, 1000);
  }

  /* ---------- filmul de fundal ---------- */
  /* Filmul (dezvăluirea premiilor) rulează o dată și rămâne pe ultimul cadru; la „mișcare redusă” arătăm direct
     ultimul cadru, cu premiile. Iese din ecran → pauză; revine → continuă, dar nu repornește după final. */
  function video(root) {
    var desk = window.matchMedia('(min-width: 750px)').matches;
    var v = root.querySelector(desk ? '.nvbfh__v-d' : '.nvbfh__v-m');
    if (!v || !v.getAttribute('data-src')) return null;
    v.src = v.getAttribute('data-src');
    if (reduce) {
      v.loop = false;
      v.preload = 'auto';
      v.addEventListener('loadedmetadata', function () { v.currentTime = Math.max(0, v.duration - 0.05); }, { once: true });
      return null;
    }
    v.preload = 'auto';
    function play() { if (v.loop || !v.ended) { var q = v.play(); if (q && q.catch) q.catch(function () {}); } }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { if (v.__go) play(); } else v.pause(); });
      }).observe(v);
    }
    return { play: function () { v.__go = true; play(); } };
  }

  /* ---------- confetti, scântei, sticle ---------- */
  /* Pe calculator, animația cuprinde și secțiunea „Ediție limitată” de imediat dedesubt (dacă există):
     o singură lume cu două pânze (canvas) — sticla care iese pe jos din hero intră sus în a doua secțiune.
     Coordonatele sunt ale lumii: y = 0 sus în hero. */
  function fx(root) {
    var canvas = root.querySelector('.nvbfh__fx');
    var amount = (parseFloat(root.getAttribute('data-fx')) || 0) / 100;
    if (!canvas || !window.gsap || reduce) return null;
    var bottleUrls = (root.getAttribute('data-bottles') || '').split('|').filter(Boolean);
    if (amount <= 0 && !bottleUrls.length) return null;
    var gold = root.getAttribute('data-c1') || '#d4a843';
    var green = root.getAttribute('data-c2') || '#22c55e';
    var palette = [gold, gold, '#f3d27a', '#b8862b', green, '#f2f7f1'];
    var W = 0, Hh = 0, Hw = 0, dpr = 1, mobile = false;
    var bits = [], sparks = [], bottles = [], sprites = [], nextSprite = 0;
    var running = false, released = false;

    /* a doua pânză: secțiunea „Ediție limitată”, dacă e imediat sub hero */
    var wrap = root.closest('.shopify-section');
    var nextSec = wrap && wrap.nextElementSibling;
    var extraRoot = nextSec && nextSec.querySelector('[data-nvbfe]');
    var extraCanvas = extraRoot && extraRoot.querySelector('.nvbfe__fx');
    var panes = [{ el: root, c: canvas, g: canvas.getContext('2d'), off: 0, h: 0, on: true, vis: true }];
    if (extraCanvas) panes.push({ el: extraRoot, c: extraCanvas, g: extraCanvas.getContext('2d'), off: 0, h: 0, on: false, vis: false, frame: extraRoot.querySelector('.nvbfe__frame') });

    /* Sticlele: decupate după conturul real (transparența) și desenate o singură dată, cu lumina verde a
       podiumurilor pe margine — ca să se vadă pe fundalul închis. Apoi doar se mută. */
    var SPR_H = 320, PAD = 28;
    function bbox(im) {
      try {
        var n = 96, c = document.createElement('canvas'); c.width = c.height = n;
        var g = c.getContext('2d'); g.drawImage(im, 0, 0, n, n);
        var d = g.getImageData(0, 0, n, n).data, x0 = n, y0 = n, x1 = -1, y1 = -1;
        for (var y = 0; y < n; y++) for (var x = 0; x < n; x++) if (d[(y * n + x) * 4 + 3] > 24) {
          if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
        if (x1 < 0) throw 0;
        return { x: Math.max(0, x0 - 1) / n, y: Math.max(0, y0 - 1) / n, w: Math.min(n, x1 + 2 - x0) / n, h: Math.min(n, y1 + 2 - y0) / n };
      } catch (e) { return { x: 0, y: 0, w: 1, h: 1 }; }
    }
    function makeSprite(im) {
      var b = bbox(im), sw = b.w * im.naturalWidth, sh = b.h * im.naturalHeight;
      var h = SPR_H, w = Math.round(h * sw / sh);
      var c = document.createElement('canvas'); c.width = w + PAD * 2; c.height = h + PAD * 2;
      var g = c.getContext('2d');
      g.shadowColor = 'rgba(34,197,94,.55)'; g.shadowBlur = 22; g.shadowOffsetY = 6;
      g.drawImage(im, b.x * im.naturalWidth, b.y * im.naturalHeight, sw, sh, PAD, PAD, w, h);
      g.shadowColor = 'transparent';
      g.drawImage(im, b.x * im.naturalWidth, b.y * im.naturalHeight, sw, sh, PAD, PAD, w, h);
      sprites.push({ c: c, k: c.height / h });
    }
    bottleUrls.forEach(function (u) {
      var im = new Image(); im.decoding = 'async';
      im.onload = function () { makeSprite(im); };
      im.src = u;
    });

    /* scânteia: un punct cu halou, desenat o singură dată */
    var glow = document.createElement('canvas'); glow.width = glow.height = 32;
    (function () {
      var g = glow.getContext('2d'), gr = g.createRadialGradient(16, 16, 0, 16, 16, 16);
      gr.addColorStop(0, 'rgba(255,240,200,1)'); gr.addColorStop(0.25, 'rgba(243,210,122,.85)'); gr.addColorStop(1, 'rgba(243,210,122,0)');
      g.fillStyle = gr; g.fillRect(0, 0, 32, 32);
    })();

    /* Pe calculator sticlele vin prin spațiile verzi libere ale hero-ului (marginea din stânga, culoarul dintre
       text și cadru, marginea din dreapta) sau de deasupra cadrului. Cadrele cu film sunt blocuri solide. */
    var zones = [], F = null, solids = [];
    function rel(r, base) { return { l: r.left - base.left, r: r.right - base.left, t: r.top - base.top, b: r.bottom - base.top }; }
    function measure() {
      var base = root.getBoundingClientRect();
      zones = []; solids = []; F = null;
      var copy = root.querySelector('.nvbfh__copy'), frame = root.querySelector('.nvbfh__bg');
      if (frame) { F = rel(frame.getBoundingClientRect(), base); solids.push(F); }
      Hw = Hh;
      if (panes[1]) {
        var p2 = panes[1];
        p2.on = !mobile;
        if (p2.on) {
          var r2 = p2.el.getBoundingClientRect();
          p2.off = r2.top - base.top; p2.h = r2.height;
          Hw = Math.max(Hh, p2.off + p2.h);
          if (p2.frame) solids.push(rel(p2.frame.getBoundingClientRect(), base));
        }
      }
      if (mobile || !copy || !F) return;
      var c = copy.getBoundingClientRect();
      var cl = c.left - base.left, cr = cl + Math.min(c.width, 560);
      [[0, cl], [cr, F.l], [F.r, W]].forEach(function (z) { if (z[1] - z[0] > 44) zones.push(z); });
    }
    function spawnX(pad) {
      pad = pad || 0;
      if (mobile || !zones.length) return rand(0, W);
      var total = 0, i;
      for (i = 0; i < zones.length; i++) total += zones[i][1] - zones[i][0];
      var r = Math.random() * total;
      for (i = 0; i < zones.length; i++) {
        var z = zones[i], w = z[1] - z[0];
        if (r <= w) return rand(z[0] + Math.min(pad, w / 2), z[1] - Math.min(pad, w / 2));
        r -= w;
      }
      return rand(0, W);
    }
    function newBit(top) {
      var s = mobile ? rand(5, 9) : rand(6, 11);
      return {
        x: spawnX(), y: top ? rand(-Hh * 0.9, -10) : rand(-20, Hh),
        w: s, h: s * rand(1.4, 2.2), vy: rand(38, 82), sway: rand(14, 34), ph: rand(0, 6.28), sp: rand(1.2, 2.6),
        rot: rand(0, 6.28), vr: rand(-2.2, 2.2), flip: rand(0, 6.28), vf: rand(3, 7),
        c: palette[(Math.random() * palette.length) | 0]
      };
    }
    /* Telefon: filmul e sus pe toată lățimea, așa că sticlele „ies” de sub marginea lui de jos, pe rând. */
    function newBottle(top) {
      var h = mobile ? rand(70, 100) : rand(100, 150);
      var b = { n: nextSprite++, h: h, hw: h * 0.16, vx: 0, vy: rand(20, 60), vmax: mobile ? rand(110, 160) : rand(96, 144), delay: 0,
        spin: 0, vs: 0, rot0: rand(-0.12, 0.12), amp: rand(0.08, 0.2), w: rand(0.6, 1.2), ph: rand(0, 6.28) };
      if (mobile && F) {
        b.x = rand(h * 0.25, W - h * 0.25);
        b.y = top ? F.b - h * 0.62 : rand(F.b, Hh);
        if (top) b.delay = rand(0, 7);
      } else {
        b.x = (F && Math.random() < 0.38) ? rand(F.l + b.hw, F.r - b.hw) : spawnX(h * 0.22);
        b.y = top ? rand(-Hw * 0.5, -h * 0.6) : rand(-h, Hw);
      }
      return b;
    }
    var GRAV = 600; /* viteza aprobată de Robert pe 31.10.2026 */
    function collide(b, dt) {
      if (mobile) return;
      for (var i = 0; i < solids.length; i++) {
        var S = solids[i], bottom = b.y + b.h * 0.5, top = b.y - b.h * 0.5;
        if (b.x + b.hw <= S.l || b.x - b.hw >= S.r || bottom <= S.t || top >= S.b) continue;
        if (bottom - b.vy * dt <= S.t + 3) {
          /* aterizează pe cadru, sare puțin și alunecă spre marginea cea mai apropiată */
          b.y = S.t - b.h * 0.5;
          if (b.vy > 50) { b.vy = -b.vy * 0.32; b.vs += (Math.random() < 0.5 ? -1 : 1) * rand(1.5, 3); } else b.vy = 0;
          var dir = b.vx ? (b.vx > 0 ? 1 : -1) : (b.x < (S.l + S.r) / 2 ? -1 : 1);
          b.vx = dir * Math.max(Math.abs(b.vx), rand(70, 110));
        } else {
          /* atinge marginea laterală: rămâne în afara cadrului */
          b.x = b.x < (S.l + S.r) / 2 ? S.l - b.hw : S.r + b.hw;
          b.vx = 0;
        }
      }
    }
    function sizePane(p, h) {
      var w = Math.round(W * dpr), hh = Math.round(h * dpr);
      if (p.c.width !== w || p.c.height !== hh) { p.c.width = w; p.c.height = hh; }
      p.g.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    /* doar măsurători și dimensiunile pânzelor (ieftin; rulează și periodic) */
    function layout() {
      var r = canvas.getBoundingClientRect();
      mobile = window.innerWidth < 750;
      dpr = Math.min(window.devicePixelRatio || 1, mobile ? 1.5 : 2);
      W = r.width; Hh = r.height;
      measure();
      panes[0].h = Hh; sizePane(panes[0], Hh);
      if (panes[1]) { if (panes[1].on) sizePane(panes[1], panes[1].h); else panes[1].g.clearRect(0, 0, panes[1].c.width, panes[1].c.height); }
    }
    function size() {
      layout();
      var nBits = Math.round((mobile ? 26 : 110) * amount);
      while (bits.length < nBits) bits.push(newBit(!released));
      bits.length = nBits;
      var nSparks = Math.round((mobile ? 14 : 30) * Math.max(amount, 0.3));
      sparks = [];
      for (var i = 0; i < nSparks; i++) sparks.push({ x: spawnX(), y: rand(0, Hh * (mobile ? 0.5 : 0.9)), r: rand(6, 14), ph: rand(0, 6.28), sp: rand(0.8, 2.2) });
      /* câte sticle: aceeași densitate pe toată înălțimea lumii */
      var nBottles = bottleUrls.length ? (mobile ? 5 : Math.min(14, Math.round(7 * Hw / Math.max(Hh, 1)))) : 0;
      while (bottles.length < nBottles) bottles.push(newBottle(!released));
      bottles.length = nBottles;
    }

    var t = 0;
    function drawBottle(g, b, off) {
      var sp = sprites[b.n % sprites.length], dh = b.h * sp.k, dw = dh * sp.c.width / sp.c.height;
      g.save(); g.globalAlpha = mobile ? 0.8 : 1;
      /* se leagănă ca un pendul, nu se dă peste cap */
      g.translate(b.x, b.y - off); g.rotate(b.rot0 + Math.sin(t * b.w + b.ph) * b.amp + b.spin);
      g.drawImage(sp.c, -dw / 2, -dh / 2, dw, dh);
      g.restore();
    }
    function frame(time, deltaTime) {
      var anyVis = panes[0].vis || (panes[1] && panes[1].on && panes[1].vis);
      if (!anyVis || document.hidden) return;
      var dt = Math.min(deltaTime, 50) / 1000; t += dt;
      var ctx = panes[0].g, i, j;
      ctx.clearRect(0, 0, W, Hh);
      if (panes[1] && panes[1].on) panes[1].g.clearRect(0, 0, W, panes[1].h);
      /* scântei care sclipesc (doar în hero) */
      ctx.globalCompositeOperation = 'lighter';
      for (i = 0; i < sparks.length; i++) {
        var p = sparks[i], a = 0.5 + 0.5 * Math.sin(t * p.sp + p.ph);
        ctx.globalAlpha = a * a * 0.9;
        ctx.drawImage(glow, p.x - p.r, p.y - p.r, p.r * 2, p.r * 2);
      }
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      if (!released) return;
      /* sticle */
      for (i = 0; i < bottles.length; i++) {
        var b = bottles[i];
        if (b.delay > 0) { b.delay -= dt; continue; }
        b.vy = Math.min(b.vy + GRAV * dt, b.vmax);
        b.x += b.vx * dt; b.y += b.vy * dt;
        b.vx *= Math.pow(0.55, dt);
        if (Math.abs(b.vx) < 2) b.vx = 0;
        collide(b, dt);
        /* înclinarea: arc amortizat — se apleacă în direcția în care alunecă și revine drept */
        b.vs += (-(b.spin - b.vx * 0.003) * 7) * dt; b.vs *= Math.pow(0.2, dt); b.spin += b.vs * dt;
        var limit = mobile ? Hh : Hw;
        if (b.y - b.h > limit) { var nb = newBottle(true); if (!mobile) nb.y = rand(-b.h * 2, -b.h); bottles[i] = nb; continue; }
        if (!sprites.length) continue;
        for (j = 0; j < panes.length; j++) {
          var P = panes[j];
          if (!P.on || !P.vis) continue;
          if (b.y + b.h > P.off && b.y - b.h < P.off + P.h) drawBottle(P.g, b, P.off);
        }
      }
      /* confetti: panglici care se rotesc și se întorc (fața/spatele mai luminoase sau mai închise) */
      for (i = 0; i < bits.length; i++) {
        var q = bits[i];
        q.y += q.vy * dt; q.rot += q.vr * dt; q.flip += q.vf * dt;
        if (q.y > Hh + 20) { bits[i] = newBit(true); bits[i].y = rand(-60, -10); continue; }
        var f = Math.cos(q.flip);
        ctx.save();
        ctx.translate(q.x + Math.sin(t * q.sp + q.ph) * q.sway, q.y); ctx.rotate(q.rot); ctx.scale(1, f);
        ctx.globalAlpha = (mobile ? 0.6 : 1) * (0.55 + 0.45 * Math.abs(f));
        ctx.fillStyle = q.c; ctx.fillRect(-q.w / 2, -q.h / 2, q.w, q.h);
        ctx.restore();
      }
      ctx.globalAlpha = 1;
    }

    size();
    var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(size, 150); });
    /* pozițiile se pot muta după încărcarea pozelor/fonturilor sau animația de intrare a secțiunii de jos */
    setInterval(function () { if (!document.hidden && (panes[0].vis || (panes[1] && panes[1].vis))) layout(); }, 1500);
    if ('IntersectionObserver' in window) {
      panes.forEach(function (P) {
        new IntersectionObserver(function (es) { P.vis = es[0].isIntersecting; }).observe(P.el);
      });
    }
    function start() { if (!running) { running = true; gsap.ticker.add(frame); } }
    start();
    return { release: function () {
      released = true; size();
      /* primele două intră imediat, restul vin eșalonat */
      for (var i = 0; i < Math.min(2, bottles.length); i++) bottles[i].y = -bottles[i].h * (0.55 + i * 0.5);
    } };
  }

  /* ---------- momentul de intrare ---------- */
  function intro(root, fxApi, vid) {
    if (!window.gsap) { root.classList.remove('is-pre'); if (fxApi) fxApi.release(); if (vid) vid.play(); return; }
    var bg = root.querySelector('.nvbfh__bg');
    var lines = root.querySelectorAll('.nvbfh__line > span');
    var rule = root.querySelector('.nvbfh__rule');
    var fades = root.querySelectorAll('[data-nvbfh-fade]');
    var mm = gsap.matchMedia();
    mm.add({ reduce: '(prefers-reduced-motion: reduce)', full: '(prefers-reduced-motion: no-preference)' }, function (c) {
      root.classList.remove('is-pre');
      if (c.conditions.reduce) {
        gsap.from([bg, lines, rule, fades], { autoAlpha: 0, duration: 0.4, ease: 'power1.out' });
        return;
      }
      var tl = gsap.timeline({ defaults: { ease: 'expo.out' } });
      tl.addLabel('light', 0)
        // fundalul se deschide din linia orizontului și se aprinde
        .fromTo(bg,
          { clipPath: 'inset(49% 0% 49% 0%)', filter: 'brightness(0.25) saturate(0.6)', autoAlpha: 1 },
          { clipPath: 'inset(0% 0% 0% 0%)', filter: 'brightness(1) saturate(1)', duration: 1.15, ease: 'expo.inOut', clearProps: 'clipPath,filter' }, 'light')
        // confetti pornește odată cu lumina
        .call(function () { if (fxApi) fxApi.release(); }, null, 'light+=0.55')
        // filmul pornește când cadrul e aproape deschis, ca dezvăluirea să se vadă de la început
        .call(function () { if (vid) vid.play(); }, null, 'light+=0.8')
        // titlul urcă din mască
        .fromTo(lines, { yPercent: 110, autoAlpha: 1 }, { yPercent: 0, duration: 0.9, stagger: 0.12 }, 'light+=0.35')
        // linia neon se trasează
        .fromTo(rule, { scaleX: 0, autoAlpha: 1 }, { scaleX: 1, duration: 0.8, ease: 'expo.inOut' }, 'light+=0.65')
        .fromTo(fades, { y: 14, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.6, stagger: 0.08, clearProps: 'transform' }, 'light+=0.85');
    });
  }

  function init() {
    document.querySelectorAll('[data-nvbfh]').forEach(function (root) {
      if (root.__nvbfh) return; root.__nvbfh = true;
      var api = fx(root);
      var vid = video(root);
      intro(root, api, vid); countdown(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
